import React from 'react';
import classNames from 'classnames';
import { ShareIcons } from '../../icons';
import styles from './share-links.module.scss';

const ShareLinks: React.FunctionComponent<{
  className?: string;
  title?: string;
  url?: string;
}> = ({
  className,
  title = 'Forbes Россия и Meta в разговоре с лидерами: На пути в цифровое будущее',
  url = process.env.REACT_APP_HOST
    || window.location.href,
}) => {
  return (
    <div
      className={classNames(
        styles.component,
        className,
      )}
    >
      <a
        title="Поделиться во ВКонтакте"
        href={`https://vk.com/share.php?url=${url}`}
        target="_blank"
        rel="noreferrer nofollow share"
      >
        <ShareIcons.VkIcon
          className={classNames(
            styles.icon,
            styles.vk,
          )}
        />
      </a>
      <a
        title="Поделиться в Facebook"
        href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
        target="_blank"
        rel="noreferrer nofollow share"
      >
        <ShareIcons.FacebookIcon
          className={classNames(
            styles.icon,
            styles.facebook,
          )}
        />
      </a>
      <a
        title="Поделиться в Одноклассниках"
        href={`https://connect.ok.ru/offer?url=${url}`}
        target="_blank"
        rel="noreferrer nofollow share"
      >
        <ShareIcons.OkIcon
          className={classNames(
            styles.icon,
            styles.ok,
          )}
        />
      </a>
      <a
        title="Поделиться в Twitter"
        href={`https://twitter.com/share?url=${url}&text=${title}`}
        target="_blank"
        rel="noreferrer nofollow share"
      >
        <ShareIcons.TwitterIcon
          className={classNames(
            styles.icon,
            styles.twitter,
          )}
        />
      </a>
    </div>
  );
}

export default ShareLinks;
